import { DmData } from '@bimser/common';
import { put, select } from 'redux-saga/effects';
import { IWebInterfaceBaseState, WebInterfaceBaseState } from '../../../../common/base/state';
import { addPanel, beginRequest, endRequest, loadContext } from '../../actions';
import updateVisibleActionsTransaction from '../../actions/panel/updateVisibleActionsTransaction';
import { AddPanelPayload, LoadContextPayload, LoadSelectedObjectsPayload } from '../../entities';
export { addNewFileToStore } from './addNewFileToStore';
export { addNewFolderToStore } from './addNewFolderToStore';
export { addNewRepositoryToStore } from './addNewRepositoryToStore';
export { callAddPanel } from './callAddPanel';
export { callExecuteCommand } from './callExecuteCommand';
export { callGetObjectContext } from './callGetObjectContext';
export { callLoadObjects } from './callLoadObjects';
export { callObjectStartupContext } from './callObjectStartupContext';
export { checkItemInFavorites } from './checkItemInFavorites';
export { getSubObjects } from './getSubObjects';
export { handleAddToClipboard } from './handleAddToClipboard';
export { handleAddToFavorite } from './handleAddToFavorite';
export { handleBatchDeleteAction } from './handleBatchDeleteAction';
export { handleClipboardMoveHereAction } from './handleClipboardMoveHereAction';
export { handleComparison } from './handleComparison';
export { handleCopyProcess } from './handleCopyProcess';
export { handleCreateShortcutObjectsAction } from './handleCreateShortcutObjectsAction';
export { handleCreateShortcutObjectsProcess } from './handleCreateShortcutObjectsProcess';
export { handleDeleteObjectsAction } from './handleDeleteObjectsAction';
export { handleDeleteRepositoryAction } from './handleDeleteRepositoryAction';
export { handleDocumentSign } from './handleDocumentSign';
export { downloadFile, handleDownloadFile } from './handleDownloadFile';
export { handleDragDrop } from './handleDragDrop';
export { handleGetGridContext } from './handleGetGridContext';
export { afterLoadMore } from './handleLoadMoreItems';
export { handleMoveProcess } from './handleMoveProcess';
export { handleNewFile } from './handleNewFile';
export { handleNewFolderService } from './handleNewFolderService';
export { handleNewRepositoryService } from './handleNewRepositoryService';
export { handleOpenContainingFolder } from './handleOpenContainingFolder';
export { handleOpenDmSecurity } from './handleOpenDmSecurity';
export { handleOpenNewFolderModal } from './handleOpenNewFolderModal';
export { handleOpenPropertiesModal } from './handleOpenPropertiesModal';
export { handleOpenShareModal } from './handleOpenShareModal';
export { handleOpenSubscriptionModal } from './handleOpenSubscriptionModal';
export { handleRefreshIndex } from './handleRefreshIndex';
export { handleRemoveFromFavorites } from './handleRemoveFromFavorites';
export { handleRename } from './handleRename';
export { handleServiceError } from './handleServiceError';
export { handleOpenOnDesktopFile, openOnDesktopChange } from './openCreateDavDocumentEditKey';
export { removeDataFromStore } from './removeDataFromStore';
export { removeItemFromScene } from './removeItemFromScene';
export { requestRepositories } from './requestRepositories';
export { sendDeleteObjectRequest } from './sendDeleteObjectRequest';
export { uploadFilesToDm } from './uploadFilesToDm';

export function* callBeginRequest(panelId: string) {
	yield put(beginRequest(panelId));
}

export function* callEndRequest(panelId: string) {
	yield put(endRequest(panelId));
}

export function* callAddSceneToPanel(payload: AddPanelPayload) {
	yield put(addPanel(payload.toJS()));
	yield put(
		updateVisibleActionsTransaction({
			panelId: payload.panelId,
			data: {
				type: 'addScene',
				data: payload.data
			}
		})
	);
}

export function* callGetObjectContextTransaction(payload: LoadContextPayload) {
	yield put(loadContext(payload));
}

export function* callLoadSelectedObjects(payload: LoadSelectedObjectsPayload) {
	yield 0;
}

export function* findParentDmData(id: string) {
	const state: WebInterfaceBaseState = yield select();
	const dmObjects: Array<DmData> = state.modules.dm.data.valueSeq().toArray();
	const parentObjIndex = dmObjects.findIndex(
		d => ['#Fav', '#Recent'].indexOf(d.id) == -1 && d.children.indexOf(id) >= 0
	);
	if (parentObjIndex > -1) {
		return dmObjects[parentObjIndex];
	} else {
		return null;
	}
}

export const getActiveScene =
	(panelId: string, sceneId?: string) => (state: WebInterfaceBaseState) => {
		if (!panelId) {
			return null;
		}
		const scenes = state.modules.dm.panels.get(panelId).scenes;
		if (sceneId) {
			return scenes.find((val, key) => val.id == sceneId);
		}
		return scenes.find((val, key) => val.isActive);
	};

export const getScene = (panelId: string, sceneId?: string) => (state: WebInterfaceBaseState) => {
	if (!panelId) {
		return null;
	}
	const panel = state.modules.dm.panels.get(panelId);
	if (!panel) {
		return null;
	}
	const scenes = panel.scenes;
	if (sceneId) {
		return scenes.find((val, key) => val.id == sceneId);
	}
	return null;
};

export const getDmObject = (id: string) => (state: WebInterfaceBaseState) => {
	if (!id) {
		return null;
	}
	return state.modules.dm.data.get(id, null);
};

export const getDmObjectFromSecretKey = (secretKey: string) => (state: WebInterfaceBaseState) =>
	state.modules.dm.data
		.valueSeq()
		.toArray()
		.find(d => d.secretKey == secretKey, null);

/**
 * @param secretKeys state'den getirilecek objelerin secretKeyleri
 * @return `Array<DmData>`
 */
export const getDmObjectsFromSecretKeys =
	(secretKeys: string[]) => (state: WebInterfaceBaseState) =>
		state.modules.dm.data
			.filter(d => secretKeys.indexOf(d.secretKey) > -1)
			.valueSeq()
			.toArray();

export const getDmObjects = (ids: string[]) => (state: WebInterfaceBaseState) => {
	if (ids.length == 0) {
		return null;
	}
	return state.modules.dm.data
		.filter(d => ids.indexOf(d.id) >= 0)
		.valueSeq()
		.toArray();
};

export const getDmObjectsAsMap = (ids: string[]) => (state: WebInterfaceBaseState) => {
	if (ids.length == 0) {
		return null;
	}
	return state.modules.dm.data.filter(d => ids.indexOf(d.id) >= 0);
};

export const getLanguages = (state: IWebInterfaceBaseState) => state.system.language.items;

export const getFavoriteObject = (id: string) => (state: WebInterfaceBaseState) =>
	state.modules.dm.data.find(i => i.id == id);

export const StartupContextMock = JSON.parse(
	'{ "result": { "permissions": { "hasDocumentManagementLicense": true, "hasRecordsManagementLicense": false, "isAdmin": true, "isReferenceFileEnabled": false, "hasPermissionShowRecycleBin": false } }, "success": true }'
);
